import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Snackbar,
} from "@mui/material";
import { useCopyToClipboard } from "usehooks-ts";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import { useCallback, useState } from "react";

export type Props = {
  topFullRows?: Array<string | number | boolean>;
  tableData: {
    [rowName: string]: string | number;
  };
  options?: {
    copyAllDefault?: boolean;
    copy?: {
      [rowName: string]: string | number | boolean;
    };
  };
};

export function SimpleDataTable({ topFullRows, tableData, options }: Props) {
  const [_copiedText, copy] = useCopyToClipboard();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const pressCopy = useCallback((label: string) => {
    const copyValue = options?.copy?.[label];
    if (copyValue === true || copyValue === undefined) {
      // Smart copy
      const valueOfLabel = tableData[label];
      const extractedNumber = valueOfLabel.toString().match(/[\d.-]+/)?.[0];
      if (!extractedNumber) {
        return;
      }

      setSnackbarOpen(true);
      copy(extractedNumber);
      return;
    }

    setSnackbarOpen(true);
    copy(copyValue.toString());
  }, []);

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={() => setSnackbarOpen(false)}
        message="Copied!"
      />
      <TableContainer component={Paper} sx={{ mt: 0, width: "100%" }}>
        <Table size="small">
          <TableBody>
            {(topFullRows ?? []).map((rowItem, i) => (
              <TableRow key={`full-${i}`}>
                <TableCell scope="row" sx={{ p: 1.5 }} colSpan={2}>
                  {rowItem?.toString()}
                  {options?.copyAllDefault ? (
                    <IconButton
                      size="small"
                      sx={{ p: 0, pl: 1, marginLeft: "auto" }}
                      onClick={() => copy(rowItem?.toString())}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
            {Object.entries(tableData).map(([label, value], i) => (
              <TableRow key={i}>
                <TableCell scope="row" sx={{ p: 1.5 }}>
                  {label}
                </TableCell>
                <TableCell align="right">
                  {value.toString()}
                  {options?.copyAllDefault || options?.copy?.[label] ? (
                    <IconButton
                      size="small"
                      sx={{ p: 0, pl: 1 }}
                      onClick={() => pressCopy(label)}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
